import styled, {css} from 'styled-components'
import {Link} from 'react-router-dom'
import { FaFacebook,FaGithub, FaInstagram, FaLinkedin, FaTwitter } from 'react-icons/fa'
import {SiGmail} from 'react-icons/si'

const sharedStyle = css`
  &:hover{
    color:#40E0D0;
    border: 2px solid #40E0D0;
    border-radius: 50%;
    padding-block: 4px;
    transform: scale(1.5);
    transition: 0.2s all ease-in-out;
    }
`

export const FooterContainer = styled.footer`
background-color: #101522;
`
export const FooterWrapper= styled.div`
padding: 30px 24px;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
max-width: 1100px;
margin: 0 auto;
`

export const FooterLinksContainer= styled.div`
display: flex;
justify-content: center;

@media screen and (max-width: 820px){
    padding-top: 32px;
}
`
export const FooterLinksWrapper= styled.div`
display: flex;

@media screen and (max-width:820px) {
    flex-direction: column;
}
`

export const FooterLinkItems= styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
margin: 16px;
text-align: left;
width: 160px;
box-sizing: border-box;
color: #fff;

@media screen and (max-width:420px) {
    margin: 0;
    padding: 10px;
    width: 100%;
}
`

export const FooterLinkTitle= styled.h1`
font-size: 14px;
margin-bottom: 16px;
`
export const FooterLink= styled(Link)`
color: #fff;
text-decoration: none;
margin-bottom: 0.5rem;
font-size: 14px;

&:hover{
    color: #40E0D0;
    transition: 0ms.3s ease-out;
}
`
// Social Media Css

export const SocialMedia= styled.section`
max-width: 1000px;
width:100%;
`
export const SocialMediaWrap= styled.div`
display: flex;
justify-content: space-between;
align-items: center;
max-width:1100px;
margin: 0 auto 0 auto;

@media screen and (max-width:820px){
    flex-direction: column;
}
`
export const SocialLogo= styled(Link)`
color: #fff;
justify-self:start;
cursor: pointer;
text-decoration: none;
font-size: 1.5rem;
display: flex;
align-items: center;
margin-bottom:16px;
font-weight: bold;
`
export const WebsiteRights= styled.small`
color:#fff;
margin-bottom: 16px;
margin-top:8px;
`

export const SocialIcons= styled.div`
display: flex;
justify-content: space-between;
align-items: center;
width: 240px;
`
export const SocialIconLink= styled.a`
color:#fff;
font-size: 24px;
`

export const FooterName= styled.span`
&::first-letter{
    font-size: 2rem;
    color: #40E0D0;
    font-family: 'cursive';
}
`

export const FaFacebookIcon=styled(FaFacebook) `
    ${sharedStyle}
`
export const FaGithubIcon=styled(FaGithub) `
    ${sharedStyle}
`
export const FaInstagramIcon=styled(FaInstagram) `
    ${sharedStyle}
`
export const FaLinkedinIcon=styled(FaLinkedin) `
    ${sharedStyle}
`
export const FaTwitterIcon=styled(FaTwitter) `
    ${sharedStyle}
`
export const SiGmailIcon=styled(SiGmail) `
    ${sharedStyle}
`

